import { Injectable, WritableSignal, signal } from '@angular/core';
import { Router } from '@angular/router';

export interface UserInfo {
  name: string;
  email: string;
}

@Injectable({
  providedIn: 'root',
})
export class PartnerStore {
  partnerAuth: WritableSignal<string | null> = signal<string | null>(null);
  userInfo: WritableSignal<UserInfo | null> = signal<UserInfo | null>(null);

  constructor(private router: Router) {
    if (localStorage.getItem('taxpayer')) {
      return;
    }

    const partnerAuth = localStorage.getItem('partnerAuth') ?? '';
    this.partnerAuth.set(partnerAuth);

    const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? 'null');
    this.userInfo.set(userInfo);
  }

  setAuthToken(token: string) {
    this.partnerAuth.set(token);
    localStorage.setItem('partnerAuth', token);
  }

  setUserInfo(userInfo: UserInfo) {
    this.userInfo.set(userInfo);
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  clearSession() {
    this.partnerAuth.set(null);
    this.userInfo.set(null);
    localStorage.clear();
    this.router.navigate(['/partner/login']);
  }
}
